import React, { useEffect } from 'react';
import { dispatchCusEvent } from '../../utils';
import { useAppSelector } from '../../store';
import { useParams } from 'react-router';
import { ENUM_CUS_EVENT } from '../../enums/enums';

export default function useGroupByGroupId() {
  const { groupId } = useParams();
  const userId = useAppSelector((state) => state.user.id);
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);

  useEffect(() => {
    if (!userId) return;
    dispatchCusEvent(ENUM_CUS_EVENT.getGroupData, { groupId, errorFn: () => {} });
    // TODO сделать errorFn - если такой группы нет и т.д
  }, [groupId, userId]);

  return { group, groupId };
}
